import type { DepartmentWithSubdepartments } from '@/types/treeViewTypes'
import { useQuery } from '@tanstack/react-query'
import { getSubdepartments } from '@/api'
import { queryKeys } from '@/query/queryKeys'

export function useSubdepartments(season: string, universeId: number, departmentId: number) {
  return useQuery({
    queryKey: queryKeys.subdepartments(universeId, departmentId, season),
    queryFn: async ({ signal }) => {
      if (!signal?.aborted)
        return getSubdepartments<DepartmentWithSubdepartments>(season, universeId, departmentId)
    },
  })
}
